import { render } from "./tw-row-edit.vue?vue&type=template&id=f21d954a&scoped=true"
import script from "./tw-row-edit.vue?vue&type=script&lang=js"
export * from "./tw-row-edit.vue?vue&type=script&lang=js"

import "./tw-row-edit.vue?vue&type=style&index=0&id=f21d954a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f21d954a"

export default script